module.exports = __webpack_public_path__ + "4f394c84eae06bc49e0492c78eb84a68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr_code2.jpg
// module id = 556
// module chunks = 0